import { render } from "./CaseClusterForm.vue?vue&type=template&id=b6882316&ts=true"
import script from "./CaseClusterForm.vue?vue&type=script&lang=ts"
export * from "./CaseClusterForm.vue?vue&type=script&lang=ts"

import "./CaseClusterForm.vue?vue&type=style&index=0&id=b6882316&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__